export interface IFinancialField {
    key: string;
    label: string;
    disabled: boolean
}

export const OWNER_FIELDS: IFinancialField[] = [
    { key: 'incomeTotal', label: '', disabled: false },
    { key: 'income1', label: 'Empleo', disabled: true },
    { key: 'income2', label: 'Empresa', disabled: true },
    { key: 'income3', label: 'Otros negocios', disabled: true },
    { key: 'income4', label: 'Alquileres', disabled: true },
    { key: 'income5', label: 'Inversiones', disabled: true },
    { key: 'income6', label: 'Otros', disabled: true }
];

export const SPOUSE_FIELDS: IFinancialField[] = [
    { key: 'incomeTotal', label: '', disabled: false },
    { key: 'income1', label: 'Empleo', disabled: true },
    { key: 'income2', label: 'Empresa', disabled: true },
    { key: 'income3', label: 'Otros negocios', disabled: true },
    { key: 'income4', label: 'Alquileres', disabled: true },
    { key: 'income5', label: 'Inversiones', disabled: true },
    { key: 'income6', label: 'Otros', disabled: true }
];

export const HOME_FIELDS: IFinancialField[] = [
    { key: 'expenseTotal', label: '', disabled: false },
    { key: 'expense1', label: 'Alquiler Hipoteca', disabled: true },
    { key: 'expense2', label: 'Telefonía/Cable/Internet y otros servicios online', disabled: true },
    { key: 'expense3', label: 'Luz', disabled: true },
    { key: 'expense4', label: 'Mantenimiento y agua', disabled: true },
    { key: 'expense5', label: 'Personal del hogar', disabled: true },
    { key: 'expense6', label: 'Supermercado (Comida, suplementos, limpieza, otros)', disabled: true },
    { key: 'expense7', label: 'Impuestos y arbitrios', disabled: true },
    { key: 'expense8', label: 'Otros', disabled: true }
];

export const MOBILITY_FIELDS: IFinancialField[] = [
    { key: 'expenseTotal', label: '', disabled: false },
    { key: 'expense1', label: 'Préstamo vehicular', disabled: true },
    { key: 'expense2', label: 'Seguro vehicular', disabled: true },
    { key: 'expense3', label: 'Gasolina', disabled: true },
    { key: 'expense4', label: 'Costo de taller y mantenimientos', disabled: true }
];

export const RECREATION_FIELDS: IFinancialField[] = [
    { key: 'expenseTotal', label: '', disabled: false },
    { key: 'expense1', label: 'Clubs', disabled: true },
    { key: 'expense2', label: 'Clases', disabled: true },
    { key: 'expense3', label: 'Gimnasio', disabled: true },
    { key: 'expense4', label: 'Cine/Museo/Cafes/Restaurantes, Deliverys, etc', disabled: true },
    { key: 'expense5', label: 'Otros', disabled: true }
];

export const TRIPS_FIELDS: IFinancialField[] = [
    { key: 'expenseTotal', label: '', disabled: false },
    { key: 'expense1', label: 'Pasajes', disabled: true },
    { key: 'expense2', label: 'Hoteles', disabled: true },
    { key: 'expense3', label: 'Comidas', disabled: true },
    { key: 'expense4', label: 'Tours', disabled: true },
    { key: 'expense5', label: 'Regalos', disabled: true },
    { key: 'expense6', label: 'Ropa y otros', disabled: true }
];

export const LOANS_FIELDS: IFinancialField[] = [
    { key: 'expenseTotal', label: '', disabled: false },
    { key: 'expense1', label: 'Préstamos bancarios', disabled: true },
    { key: 'expense2', label: 'Otros préstamos', disabled: true }
];

export const EXTRAS_FIELDS: IFinancialField[] = [
    { key: 'expenseTotal', label: '', disabled: false },
    { key: 'expense1', label: 'Extras', disabled: true }
];

export const HEALTH_FIELDS: IFinancialField[] = [
    { key: 'expenseTotal', label: '', disabled: false },
    { key: 'expense1', label: 'Seguros de vida', disabled: true },
    { key: 'expense2', label: 'Plan de ahorro jubilación/estudios', disabled: true },
    { key: 'expense3', label: 'Seguro de salud', disabled: true },
    { key: 'expense4', label: 'Consultas médicas', disabled: true },
    { key: 'expense5', label: 'medicinas', disabled: true }
];

export const EDUCATION_FIELDS: IFinancialField[] = [
    { key: 'expenseTotal', label: '', disabled: false },
    { key: 'expense1', label: 'Pensión de colegio(s)', disabled: true },
    { key: 'expense2', label: 'Cuota de universidad(es)', disabled: true },
    { key: 'expense3', label: 'Cuota Diplomado/Maestría', disabled: true },
    { key: 'expense4', label: 'Materiales y otros', disabled: true }
];

export const NON_PRODUCTIVE_ASSETS_FIELDS: IFinancialField[] = [
    { key: 'nonProductiveAssetsTotal', label: '', disabled: false },
    { key: 'nonProductiveAssets1', label: 'Casa/Departament (Vivienda)', disabled: true },
    { key: 'nonProductiveAssets2', label: 'Otros inmuebles', disabled: true },
    { key: 'nonProductiveAssets3', label: 'Autos', disabled: true },
    { key: 'nonProductiveAssets4', label: 'Otros activos no productivos', disabled: true }
];

export const PRODUCTIVE_ASSETS_FIELDS: IFinancialField[] = [
    { key: 'productiveAssetsTotal', label: '', disabled: false },
    { key: 'productiveAssets1', label: 'FONDO DE EMERGENCIA (Cuenta ahorros inmovilizada)', disabled: true },
    { key: 'productiveAssets2', label: 'CUENTA AHORROS / DEPÓSITOS A PLAZO / BONOS', disabled: true },
    { key: 'productiveAssets3', label: 'INVERSIONES EN BIENES INMUEBLES* (Conservadores)', disabled: true },
    { key: 'productiveAssets4', label: 'FONDOS MUTUOS LOCALES (Bancos)', disabled: true },
    { key: 'productiveAssets5', label: 'NOTAS ESTRUCTURADAS', disabled: true },
    { key: 'productiveAssets6', label: 'FONDOS EN EL EXTRANJERO DE BAJO RIESGO / ACCIONES / ETFs', disabled: true },
    { key: 'productiveAssets7', label: 'PLANES DE AHORRO DE LARGO PLAZO', disabled: true },
    { key: 'productiveAssets8', label: 'AFP, ONP O FONDO DE PENSIONES', disabled: true },
    { key: 'productiveAssets9', label: 'OTRAS INVERSIONES CONSERVADORAS', disabled: true },
    { key: 'productiveAssets10', label: 'INVERSIONES EN BIENES INMUEBLES (Moderado)', disabled: true },
    { key: 'productiveAssets11', label: 'INVERSIONES EN BIENES MUEBLES (Moderado)', disabled: true },
    { key: 'productiveAssets12', label: 'ACCIONES EN EMPRESAS (Grandes empresas)', disabled: true },
    { key: 'productiveAssets13', label: 'OTRAS INVERSIONES MODERADAS', disabled: true },
    { key: 'productiveAssets14', label: 'OPCIONES, FUTUROS , CFDs (Forex)', disabled: true },
    { key: 'productiveAssets15', label: 'ACCIONES EN STARTUPS', disabled: true },
    { key: 'productiveAssets16', label: 'CRIPTOMONEDAS', disabled: true },
    { key: 'productiveAssets17', label: 'OTRAS INVERSIONES AGRESIVAS', disabled: true }
];

export const LIABILITIES_FIELDS: IFinancialField[] = [
    { key: 'liabilitiesTotal', label: '', disabled: false },
    { key: 'liabilities1', label: 'PRÉSTAMO HIPOTECARIO', disabled: true },
    { key: 'liabilities2', label: 'PRÉSTAMO VEHICULAR', disabled: true },
    { key: 'liabilities3', label: 'OTROS PRÉSTAMOS CON ENTIDADES FINANCIERAS', disabled: true },
    { key: 'liabilities4', label: 'PRÉSTAMOS EN BANCA PARALELA', disabled: true },
    { key: 'liabilities5', label: 'PRÉSTAMOS CON PERSONAS NATURALES', disabled: true },
    { key: 'liabilities6', label: 'OTRAS CUENTAS POR PAGAR', disabled: true }
];

export const UNIQUE_EXPENSE_FIELDS: IFinancialField[] = [
    { key: 'expenseTotal', label: '', disabled: false }
];

export const FIELDS_MAP = (key: string) => ({
    owner: OWNER_FIELDS,
    spouse: SPOUSE_FIELDS,
    home: HOME_FIELDS,
    mobility: MOBILITY_FIELDS,
    recreation: RECREATION_FIELDS,
    trips: TRIPS_FIELDS,
    loans: LOANS_FIELDS,
    extras: EXTRAS_FIELDS,
    health: HEALTH_FIELDS,
    education: EDUCATION_FIELDS,
    nonProductiveAssets: NON_PRODUCTIVE_ASSETS_FIELDS,
    productiveAssets: PRODUCTIVE_ASSETS_FIELDS,
    liabilities: LIABILITIES_FIELDS,
    uniqueExpense: UNIQUE_EXPENSE_FIELDS
}[key] || []);